module.exports = __webpack_public_path__ + "img/Lotsenstelle.65f3e76e.svg";